import { create } from 'zustand'

export type ToastKind = 'success' | 'error'

interface Toast {
  id: number
  kind: ToastKind
  message: string
}

interface ToastState {
  /** 表示中のお知らせ。新しいものが来たら置き換える（積み上げない） */
  toast: Toast | null
  show: (message: string, kind?: ToastKind) => void
  dismiss: (id: number) => void
}

let nextId = 1

export const useToastStore = create<ToastState>((set) => ({
  toast: null,
  show: (message, kind = 'success') => set({ toast: { id: nextId++, kind, message } }),
  // タイマーが古いお知らせを消すとき、後から出たお知らせまで消さないよう id で確かめる
  dismiss: (id) => set((state) => (state.toast?.id === id ? { toast: null } : state)),
}))

/** React の外（非同期処理の結果など）からも呼べるようにする */
export function showToast(message: string, kind?: ToastKind) {
  useToastStore.getState().show(message, kind)
}
